export default __webpack_public_path__ + "ef1ffdfbd98b53fef599f19fa3570305.png";